<companyid-content-wrapper classNames="flex-col w-full py-80px gap-y-40px tab:px-5 mob:px-5">
    <companyid-title-and-subtitle
        title="Pricing"
        subtitle="Discover CompanyID"
        i18n-title="@@title-pricing"
        i18n-subtitle="@@subtitle-discover-companyid"
    />
    <div class="flex justify-between items-center mob:flex-col w-full mob:gap-y-40px mob:items-stretch">
        <companyid-button-group [buttonItems]="monthlyButtons" />
        <companyid-price-dropdown class="self-end" />
    </div>

    <div class="flex w-full gap-x-30px gap-y-40px tab:gap-y-30px tab:flex-col mob:flex-col mob:gap-y-30px">
        @for (item of pricingPlansItems; track item.title) {
            <div class="flex flex-col w-full p-30px gap-y-30px rounded-6px border border-solid border-dark-7 bg-white">
                <div class="flex flex-col gap-y-15px text-dark">
                    <span class="text-h6-semi-bold">{{ item.title }}</span>
                </div>
                <!--    // TODO(andriikamaldinov1): uncommit when we have real pricing-->

                <!--                <companyid-button-group leftSideTitle="Per User" rightSideTitle="Per Team" />-->
                <div class="flex flex-col gap-y-15px">
                    <span class="text-dark text-medium-semi-bold" i18n=":@@pricing-feature-includes"
                        >Features includes:</span
                    >
                    <div class="flex flex-col gap-y-2.5">
                        @for (feature of item.features; track feature) {
                            <div class="flex items-center gap-x-15px text-medium-regular text-primary-text-color">
                                <img
                                    [ngSrc]="'checkmark-circle' | asset: 'pricing'"
                                    width="16"
                                    height="17"
                                    alt="checkmark-circle"
                                />
                                {{ feature }}
                            </div>
                        }
                        @if (item.featuresSoon?.length) {
                            @for (feature of item.featuresSoon; track feature) {
                                <div
                                    class="flex items-center gap-x-15px text-medium-regular text-primary-text-color opacity-55"
                                >
                                    <img
                                        [ngSrc]="'reload' | asset: 'pricing'"
                                        width="16"
                                        height="17"
                                        alt="checkmark-circle"
                                    />
                                    {{ feature }}

                                    <span
                                        class="bg-primary-text-color rounded-3px text-white text-extra-small-medium px-2"
                                        i18n=":@@pricing-soon"
                                        >Soon</span
                                    >
                                </div>
                            }
                        }
                    </div>
                </div>
                <!--    // TODO(andriikamaldinov1): uncommit when we have real price-->

                <!--                <div class="flex flex-col gap-y-15px text-medium-regular text-primary-text-color">-->
                <!--                    <div class="flex justify-between">-->
                <!--                        <span>Per Team:</span>-->
                <!--                        <span class="text-dark text-fs-26-normal">$ {{ item.pricePerTeam }} </span>-->
                <!--                    </div>-->
                <!--                    <div class="flex justify-between">-->
                <!--                        <span>Per User:</span> <span>$ {{ item.pricePerUser }} </span>-->
                <!--                    </div>-->
                <!--                </div>-->

                <a class="button-ghost-white mt-auto" routerLink="/contact-us">
                    <span class="text-dark" i18n>Contact sales</span>
                    <companyid-arrow color="black" position="right" />
                </a>
            </div>
        }
    </div>
    <!--    // TODO(andriikamaldinov1): uncommit when we have real description-->

    <!--    <span class="text-center text-dark text-large-regular">-->
    <!--        Price per seat, billed annually. Viewers are always free. <br />-->
    <!--        *Booster Pack also available for $40/user, billed month-to-month.-->
    <!--    </span>-->

    <hr class="h-[5px]" />

    <div class="flex w-full mob:flex-col">
        <companyid-feature-item [feature]="feature" class="flex w-full mob:justify-center tab:justify-center" />
    </div>
</companyid-content-wrapper>
